import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const Optometry = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my optometry business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps optometry businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for optometry businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most optometry businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my optometry business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like optometry. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Optometry - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Optometry CRM", url: "/industries/optometry" }
  ];

  const industryData = {
    name: 'Optometry Practice',
    title: 'Fill Your Schedule & Increase Eyewear Sales',
    subtitle: 'Automate exam reminders, reduce no-shows, and boost frame and contact lens sales',
    icon: '👓',
    challenges: [
      'Patients forget annual exams',
      'High no-show rates',
      'Low eyewear conversion rates',
      'Contact lens reorder rates are low',
      'Insurance pre-authorization delays'
    ],
    solutions: [
      'Annual exam reminder automation',
      'Appointment reminder system',
      'Frame selection follow-up',
      'Contact lens reorder reminders',
      'Insurance verification automation'
    ],
    features: [
      'Patient CRM with exam history',
      'Annual exam reminders',
      'Appointment confirmations',
      'Eyewear try-on booking',
      'Contact lens reorder alerts',
      'Insurance verification',
      'Prescription tracking',
      'Review automation'
    ],
    results: [
      '75% annual exam compliance',
      '40% reduction in no-shows',
      '50% increase in eyewear sales',
      '£6.4K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Optometry UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for optometry businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for optometry UK, optometry business software, optometry customer management, optometry lead generation UK"
        url="/industries/optometry"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default Optometry;